import React, { memo, useContext, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import CartContext from "../../cartcontext/CartContext";

function NavBar(props) {
  const { toggleCart } = props;
  const { cartState, countCart } = useContext(CartContext);
  const [navExpanded, setNavExpanded] = useState(false);

  const { pathname } = useLocation();

  return (
    <div className="position-fixed shadow" style={{ zIndex: 2, width: "100%" }}>
      <Navbar bg="light" expand="lg" expanded={navExpanded}>
        <Navbar.Brand href="#home" className="d-none d-md-inline d-lg-inline">
          VEG TIFFIN
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="mx-2"
          onClick={() => {
            navExpanded ? setNavExpanded(false) : setNavExpanded(true);
          }}
        ></Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="/#home">
              <li className="nav-item">HOME</li>
            </Nav.Link>
            <Nav.Link href="/#menu">
              <li className="nav-item">MENU</li>
            </Nav.Link>
            <Nav.Link href="/order/online">
              <li className="nav-item"> ORDER ONLINE</li>
            </Nav.Link>
            <Nav.Link href="/#contact">
              <li className="nav-item">CONTACT</li>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        {pathname !== "/order/checkout" ? (
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a
                className="nav-link text-light btn btn-danger btn-sm px-2"
                onClick={() => {
                  toggleCart();
                  setNavExpanded(false);
                }}
              >
                <img
                  src="../../assets/icons/shopping_cart-24px.svg"
                  className="mx-2"
                />
                CART {countCart()}
              </a>
            </li>
          </ul>
        ) : (
          ""
        )}
      </Navbar>
    </div>
  );
}

export default memo(NavBar);
